export default {
	"headerSubMenu.overview": "Übersicht",
} as const;
